import AbstractVendorBetConfig from "../../vendor_core/src/vendorConfigs/AbstractVendorBetConfig";

class BetConfig extends AbstractVendorBetConfig {
    public betOptions = [];
}

export default new BetConfig();
